import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
export const defaultCategory = {
	categoryId: 1,
	text: 'Categoria',
};
export const defaultCustom = {
	type: 'internal',
	href: '/',
	noFollow: false,
	text: 'Coleção',
};
export function MenuItem(props, childrenComponents = [], blocks = []) {
	const defCat = { ...defaultCategory };
	const defCus = { ...defaultCustom };
	return {
		componentName: 'MenuItem',
		componentId: uuidv4(),
		props: _.merge(
			{
				id: 'menu-item-category-apparel',
				type: 'custom',
				iconId: null,
				highlight: false,
				onMountBehavior: 'closed',
				itemProps: props?.type == 'category' ? defCat : defCus,
			},
			props,
		),
		blocks,
		childrenComponents,
	};
}

// {
//   componentName: 'Submenu',
//   componentId: uuidv4(),
//   props: {},
//   childrenComponents: [
//     {
//       componentName: 'Menu',
//       componentId: uuidv4(),
//       props: {
//         orientation: 'vertical',
//       },
//       childrenComponents: [
//         {
//           componentName: 'MenuItem',
//           componentId: uuidv4(),
//           props: {
//             id: 'menu-item-category-apparel-clothing',
//             type: 'custom',
//             iconId: null,
//             highlight: false,
//             itemProps: {
//               type: 'internal',
//               href: '/apparel---accessories/clothing/',
//               noFollow: false,
//               tagTitle: 'Clothing',
//               text: 'Clothing',
//               itemType: 'custom',
//             },
//           },
//         },
//         {
//           componentName: 'MenuItem',
//           componentId: uuidv4(),
//           props: {
//             id: 'menu-item-category-apparel-accessories',
//             type: 'custom',
//             iconId: null,
//             highlight: false,
//             itemProps: {
//               type: 'internal',
//               href: '/apparel---accessories/accessories/',
//               noFollow: false,
//               tagTitle: 'Accessories',
//               text: 'Accessories',
//               itemType: 'custom',
//             },
//           },
//         },
//         {
//           componentName: 'MenuItem',
//           componentId: uuidv4(),
//           props: {
//             id: 'menu-item-category-apparel-eyeglasses',
//             type: 'custom',
//             iconId: null,
//             highlight: false,
//             itemProps: {
//               type: 'internal',
//               href: '/apparel---accessories/eyeglasses/',
//               noFollow: false,
//               tagTitle: 'Eyeglasses',
//               text: 'Eyeglasses',
//               itemType: 'custom',
//             },
//           },
//         },
//       ],
//     },
//   ],
// },
